<template>
  <div class="copypage about">

    <header>
      <div class="grid-container">
        <router-link to="/"><img class="logo" src="../assets/images/global/logo.svg"></router-link>
        <router-link class="btn bg-three active" to="/register">Sign Up</router-link>
      </div>
    </header>

    <section class="background-image">
      <div class="grid-container">
        <div class="col-6">

          <h2>About Us</h2>

          <p>The PEI exChange is the first online matching platform for all those passionate about African development.</p>

          <p>Based on user-identified criteria, including countries and regions of focus, industries, skills and experience, the PEI exChange provides personalised matches to help make your ‘Big Ideas for Africa’ a reality.</p>

          <p>Whatever it is – a charitable project, a business plan or an academic proposal – the PEI exChange makes it possible to connect with the right people, exchange ideas and knowledge and build networks to support your Big Ideas.</p>

          <p>We want to help you collaborate and innovate and stimulate. Wherever you are and whatever you need, the PEI exChange connects you to Africa.</p>

          <p>Join today and let’s drive real change for African development.</p>

          <p class="small">The PEI exChange is delivered by the Planet Earth Institute (PEI), and charity and NGO working for the scientific independence of Africa.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?5928946a